import DxmlSpan from "../DxmlRun/DxmlSpan";
import { useContext } from "react"
import { WebEditorContext } from "../../../../../contexts";
import { format } from 'date-fns';

export default function DxmlAutoDate({ editorAutoDate }) {
    const { editorFileRef } = useContext(WebEditorContext);
    const editorFontDef = editorFileRef.current.EditorFontLibrary?.Fonts.find(x => x.Id === editorAutoDate.EditorFontDefId);

    const toISODateString = (date) => {
        return date.toISOString().split('T')[0];
    }

    const now = new Date();
    let currentDateString = toISODateString(now);
    if (editorAutoDate.Format) {
        try {
            currentDateString = format(now, editorAutoDate.Format);
        } catch (err) {
            // invalid format or can not format date
        }
    }

    return (
        <DxmlSpan text={currentDateString} cssStyle={editorAutoDate.ReactCssStyle} editorFontDef={editorFontDef} />
    )
}